
export class FaMarkerIcon {
  protected faClasses = ['fas', 'fa-circle'];
  protected colorHex = '#ffffff';
  protected sizePercent = 33;

  constructor() {
  }

  public configure(
    faClasses: Array<string>,
    colorHex?: string,
    sizePercent?: number,
  ): this {
    this.faClasses = (faClasses != null) ? faClasses : this.faClasses;
    this.colorHex = (colorHex != null) ? colorHex : this.colorHex;
    this.sizePercent = (sizePercent != null) ? sizePercent : this.sizePercent;
    return this;
  }


  public createElement(): HTMLElement {
    const icon = document.createElement('i');
    this.faClasses.forEach((cssClass: string) => icon.classList.add(cssClass));
    icon.classList.add('fa-marker-icon-icon');
    icon.classList.add('fa-marker-overlay');
    icon.style.fontSize = `${this.sizePercent}%`;
    icon.style.color = this.colorHex;

    return icon;
  }

}
